export default __webpack_public_path__ + "static/media/logo.a772cee7.png";